<div>
  <button nz-button nzDanger (click)="showModal()">Добавить замечание</button>
  <nz-modal [(nzVisible)]="isVisible" nzTitle="Добавить комментарий" (nzOnCancel)="handleCancel()"
            (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
      <form nz-form nzLayout="vertical" [formGroup]="valueForm">
        <nz-form-item>
          <nz-form-label>Значение</nz-form-label>
          <textarea nz-input rows="10" formControlName="value"></textarea>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
</div>
